import Game from '../../../Game';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { getHighestLevelCompleted } from '../../../State/Player/PlayerLevelHelper';
import { TimerType } from '../../../System/Timer/TimerTypes';
import { Immutable } from '../../Types';
import DateHelper from '../../DateHelper';
import { FBTrackingEvent } from '../FBTrackingEvent';

export class HeavyUsersTracking {

    public static trackHeavyUserAdsIfNeeded(
        playerState: Immutable<IPlayerState>
    ) {
        if (!this.canTrackHeavyUser(playerState)) return;
        const totalAdsWatched = playerState.progress.totalAdsWatched;
        if (totalAdsWatched === 5) {
            Game.sdk.gameTracking(FBTrackingEvent.Adwhales_24h_5_ads);
        } else
        if (totalAdsWatched === 10) {
            Game.sdk.gameTracking(FBTrackingEvent.Adwhales_24h_10_ads);
        }
    }

    public static trackHeavyUserLevelFirstCompleteIfNeeded(
        playerState: Immutable<IPlayerState>
    ) {
        if (!this.canTrackHeavyUser(playerState)) return;
        const levelsCompleted = getHighestLevelCompleted(playerState);
        if (levelsCompleted === 10) {
            Game.sdk.gameTracking(FBTrackingEvent.HeavyUsers_24h_10_lvl_complete);
        } else
        if (levelsCompleted === 20) {
            Game.sdk.gameTracking(FBTrackingEvent.HeavyUsers_24h_20_lvl_complete);
        }
    }

    private static canTrackHeavyUser(
        playerState: Immutable<IPlayerState>
    ) {
        const initialLoginTime = playerState.timers.get(TimerType.INITIAL_LOGIN);
        if (!initialLoginTime) return false;
        if (DateHelper.timeSince(initialLoginTime) > DateHelper.Day) return false;
        return true;
    }
}
